import { FC, useState } from 'react';
import styled from 'styled-components';
import RegistrazioneModale from './RegistrazioneModale';
import LoginModale from './LoginModale';
import ForgotPasswordModale from './ForgotPasswordModale';
import { apiCreateUser, apiLogUser } from '../ui_components/ApiList';
import type { LoginCredentials, RegisterPayload, User } from '../../types';

const Container = styled.div`
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
  }

  & button.section_name {
    color: white;
    border-color: white;
  }
`;

const LoginSectionHeader: FC = () => {
  const [isRegistrazioneVisibile, setIsRegistrazioneVisibile] = useState<boolean>(false);
  const [isLoginVisible, setIsLoginVisible] = useState<boolean>(false);
  const [isForgotPasswordVisible, setIsForgotPasswordVisible] = useState<boolean>(false);

  const handleOpenModal = (loginclick: boolean = false): void => {
    loginclick ? setIsLoginVisible(true) : setIsRegistrazioneVisibile(true);
  };

  const handleCloseModal = (loginclick: boolean = false): void => {
    loginclick ? setIsLoginVisible(false) : setIsRegistrazioneVisibile(false);
  };

  const closeLoginOpenRegistrazione = (): void => {
    setIsLoginVisible(false);
    setIsRegistrazioneVisibile(true);
  };

  const closeLoginOpenForgotPassword = (): void => {
    setIsLoginVisible(false);
    setIsForgotPasswordVisible(true);
  };

  const closeForgotPasswordOpenLogin = (): void => {
    setIsForgotPasswordVisible(false);
    setIsLoginVisible(true);
  };

  const createNewUser = async (userData: RegisterPayload): Promise<unknown> => {
    try {
      const responseApiCreateUser = await apiCreateUser(userData);
      return responseApiCreateUser;
    } catch (error) {
      throw error;
    }
  };

  const logUser = async (userData: LoginCredentials): Promise<unknown> => {
    try {
      const responseApiLogUser = await apiLogUser(userData);
      return responseApiLogUser;
    } catch (error) {
      throw error;
    }
  };

  return (
    <Container className="LoginSection d-flex align-items-center col-4 col-md-4">
      <button
        type="button"
        className="section_name btn btn-outline-primary mx-2"
        onClick={() => handleOpenModal(true)}
      >
        Login
      </button>
      {isLoginVisible && (
        <LoginModale
          closeModalClick={() => handleCloseModal(true)}
          closeLoginOpenRegistrazione={() => closeLoginOpenRegistrazione()}
          openForgotPassword={() => closeLoginOpenForgotPassword()}
          logUser={logUser}
        />
      )}
      {isForgotPasswordVisible && (
        <ForgotPasswordModale
          closeModalClick={() => setIsForgotPasswordVisible(false)}
          openLogin={() => closeForgotPasswordOpenLogin()}
        />
      )}

      <button
        disabled={isLoginVisible}
        type="button"
        className="section_name btn btn-outline-primary d-none d-md-block"
        onClick={() => handleOpenModal()}
      >
        Registrati
      </button>
      {isRegistrazioneVisibile && (
        <RegistrazioneModale
          closeModalClick={() => handleCloseModal()}
          createNewUser={createNewUser}
        />
      )}
    </Container>
  );
};

export default LoginSectionHeader;
